import { exit } from 'ionicons/icons';

/** Order sub types as the API names them; this is what gets stored on pickupInfo.location */
export enum PickupTypeEnum {
    pickUp = 'Pick Up',
    curbside = 'Curbside',
    window = 'Window',
    dineIn = 'Dine In',
    communityRoom = 'Community Room',
    delivery = 'Delivery',
}

export const OrderType = Object.freeze([
    // At Store
    { name: PickupTypeEnum.pickUp, display: 'Pick Up Inside', icon: require('@/assets/pick_up_icon.svg'), isDelivery: false, logo: 'counterPickupPep.png' },
    { name: PickupTypeEnum.curbside, display: 'Curbside', icon: exit, isDelivery: false, logo: 'curbsidePickupPep.png' },
    { name: PickupTypeEnum.window, display: 'Pick-Up Window', icon: require('@/assets/window_icon.svg'), isDelivery: false, logo: 'windowPickupPep.png' },
    { name: PickupTypeEnum.dineIn, display: 'Eat In', icon: require('@/assets/eat_in_icon.svg'), isDelivery: false, logo: 'superHappyPep.png' },
    { name: PickupTypeEnum.communityRoom, display: 'Community Room', icon: exit, isDelivery: false, logo: 'superHappyPep.png' },
    // Delivery
    { name: PickupTypeEnum.delivery, display: 'Delivery', icon: require('@/assets/delivery_icon.svg'), isDelivery: true, logo: 'deliveryPep.png' },
]);

export enum OrderTypeEnum {
    pickup = 'Pick up',
    delivery = 'Delivery',
}

export const OrderTypeSortOrder: ReadonlyArray<string> = Object.freeze([
    PickupTypeEnum.window,
    PickupTypeEnum.curbside,
    PickupTypeEnum.pickUp,
    PickupTypeEnum.dineIn,
    PickupTypeEnum.communityRoom,
    PickupTypeEnum.delivery,
]);
